import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../../twc.refresh-layer-plugin.service';
import { WINDS_ALOFT_PRODUCT_DATA } from './winds-aloft.twc-product-data';
import { TEMPS_WINDS_ALOFT_LEGEND } from './temps-winds-aloft.legend';

@Injectable({
  providedIn: 'root'
})
export class WindsAloftPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(WINDS_ALOFT_PRODUCT_DATA, {
    twcLayerTypes: ['vector-tile'],
    legend: TEMPS_WINDS_ALOFT_LEGEND
  });
}
